import React from 'react';
import { withRouter } from 'react-router-dom';

import * as ROUTES from '../../../constants/routes';

import { doSignOut } from '../../../firebase/api/auth';
import { getUserUid, hasAcceptPolicy } from '../../../static/localStorage';

import { Button } from '../../elements/buttons/Button';

import './MainNavbar.css';
import InviteFriendsModal from '../../elements/modal/InviteFriendsModal';
import { getUserByUid } from '../../../firebase/api/users';
import { LogoIcon } from '../../elements/icons/Icons';
import { LogOutIcon } from '../../elements/icons/Icons';
import { MobileNavIcon } from '../../elements/icons/Icons';
import { MobileNavCloseIcon } from '../../elements/icons/Icons';
import SignInModalForm from '../../elements/customModals/SignInModalForm/SignInModalForm';
import ForgotPassword from '../../elements/customModals/ForgotPassword';
import SignUpModalForm from '../../elements/customModals/SignUpModalForm/SignUpModalForm';
import { randomKey } from '../../../static/utils';
import ContactModal from '../../elements/customModals/InformationModal/ContactModal';
import AboutModal from '../../elements/customModals/InformationModal/AboutModal';
import AccountSettingsModal from '../../elements/customModals/AccountSettingsModal/AccountSettingsModal';
import ResponsiveMenu from 'react-responsive-navbar';
import { getUserTeams } from '../../../firebase/api/teams';
import MyTeamsModal from '../../elements/customModals/MyTeamsModal/MyTeamsModal';

class MainNavbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userUid: null,
            user: null,
            acceptPolicy: false,
            signIn: false,
            signUp: false,
            modal: false,
            previewPostUid: null,
            showAboutModal: false,
            showContactModal: false,
            showAccountSettingsModal: false,
            showForgotPasswordModal: false,
            inviteCode: randomKey(24),
            invitationKey: null,
            showMyTeamsModal: false,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const userUid = getUserUid();

        prevState.user === null &&
            userUid &&
            getUserByUid(userUid).then(user => {
                this.setState({ user });
            });

        const acceptPolicy = hasAcceptPolicy();
        if (userUid !== prevState.userUid || acceptPolicy !== prevState.acceptPolicy) {
            this.setState({ userUid, acceptPolicy });
        }
    }

    signOut = () => {
        doSignOut().then(() => this.props.history.push(ROUTES.LANDING));
    };

    escFunction = event => {
        if (event.keyCode === 27) {
            this.handleClose();
        }
    };

    toggleSingIn = () => {
        this.setState(prevState => ({
            signIn: !prevState.signIn,
        }));
    };

    signUpToggle = () => {
        this.setState(prevState => ({
            signUp: !prevState.signUp,
        }));
    };
    forgotPasswordToggle = () => {
        this.setState(prevState => ({
            showForgotPasswordModal: !prevState.showForgotPasswordModal,
        }));
    };

    toggleModal = () => {
        this.setState(prevState => ({
            modal: !prevState.modal,
        }));
    };

    handleClose = () => this.setState({ signIn: false, signUp: false });

    render() {
        const {
            userUid,
            signIn,
            signUp,
            modal,
            user,
            showAboutModal,
            showContactModal,
            showAccountSettingsModal,
            previewPostUid,
            showForgotPasswordModal,
            showMyTeamsModal,
        } = this.state;
        return (
            <nav
                className={`navbar logged-nav static-top ${
                    this.props.history.location.pathname === '/' && 'dark'
                }`}
            >
                <a className="navbar-brand" onClick={() => this.props.history.push(ROUTES.POSTS)}>
                    <LogoIcon />
                </a>

                {userUid ? (
                    <ResponsiveMenu
                        menuOpenButton={<MobileNavIcon />}
                        menuCloseButton={<MobileNavCloseIcon />}
                        changeMenuOn="651px"
                        largeMenuClassName="desktop-nav"
                        smallMenuClassName="mobile-nav"
                        className="res-menu"
                        menu={
                            <div className="d-flex mt-2 menu">
                                {/*<Button
                            classes="btn btn-link pr-0"
                            title="Home"
                            onClick={() => this.props.history.push(ROUTES.POSTS)}/> */}
                                {/*<Button*/}
                                {/*    classes="btn btn-link disabled"*/}
                                {/*    title="Contact"*/}
                                {/*    onClick={() => this.props.history.push(ROUTES.POSTS)}*/}
                                {/*/>*/}
                                <Button
                                    classes="btn btn-link mobile-only"
                                    title="Dashboard"
                                    onClick={() => window.location.reload()}
                                />
                                <Button
                                    classes="btn btn-link"
                                    title="Create Teams"
                                    onClick={() =>
                                        this.setState({ showMyTeamsModal: !showMyTeamsModal })
                                    }
                                />
                                <Button
                                    classes="btn btn-link"
                                    title="Account Settings"
                                    onClick={() =>
                                        this.setState({
                                            showAccountSettingsModal: !showAccountSettingsModal,
                                        })
                                    }
                                />
                                <Button
                                    classes="btn btn-link inviteFriendsButton"
                                    title="Invite friends"
                                    onClick={() => this.toggleModal()}
                                />

                                <Button
                                    classes="btn logOutButton"
                                    title="Log out"
                                    onClick={this.signOut}
                                    icon={<LogOutIcon />}
                                />
                            </div>
                        }
                    />
                ) : (
                    <ResponsiveMenu
                        menuOpenButton={<MobileNavIcon />}
                        menuCloseButton={<MobileNavCloseIcon />}
                        changeMenuOn="651px"
                        largeMenuClassName="desktop-nav-landing"
                        smallMenuClassName="mobile-nav-landing"
                        menu={
                            <div className="d-flex mt-2 desktop-nav">
                                <nav className="landing-nav">
                                    <div
                                        className={
                                            !showAboutModal && !showContactModal ? 'active' : ''
                                        }
                                        onClick={() => window.location.reload()}
                                    >
                                        Home
                                    </div>
                                    <div
                                        className={showAboutModal ? 'active' : ''}
                                        onClick={() =>
                                            this.setState({ showAboutModal: !showAboutModal })
                                        }
                                    >
                                        About
                                    </div>
                                    <div
                                        className={showContactModal && 'active'}
                                        onClick={() =>
                                            this.setState({ showContactModal: !showContactModal })
                                        }
                                    >
                                        Contact
                                    </div>

                                    <Button
                                        classes="btn btn-outline-dark mx-2"
                                        title="Sign In"
                                        onClick={() => this.setState({ signIn: true })}
                                    />
                                </nav>
                            </div>
                        }
                    />
                )}
                {signIn && (
                    <SignInModalForm
                        toggle={this.toggleSingIn}
                        modal={signIn}
                        previewPostUid={previewPostUid}
                        redirectToSignUp={() => {
                            this.toggleSingIn();
                            this.signUpToggle();
                        }}
                        redirectToForgotPassword={() => {
                            this.toggleSingIn();
                            this.forgotPasswordToggle();
                        }}
                    />
                )}
                {showForgotPasswordModal && (
                    <ForgotPassword
                        modal={showForgotPasswordModal}
                        toggle={this.forgotPasswordToggle}
                        redirectToSignIn={() => {
                            this.forgotPasswordToggle();
                            this.toggleSingIn();
                        }}
                    />
                )}
                {signUp && (
                    <SignUpModalForm
                        toggle={this.signUpToggle}
                        modal={signUp}
                        previewPostUid={previewPostUid}
                        inviteCode={this.state.inviteCode}
                        invitationKey={this.state.invitationKey}
                    />
                )}
                {user && (
                    <InviteFriendsModal
                        inviteCode={user.inviteCode}
                        modal={modal}
                        toggle={this.toggleModal}
                    />
                )}
                <ContactModal
                    modal={showContactModal}
                    toggle={() => this.setState({ showContactModal: !showContactModal })}
                />
                <AboutModal
                    modal={showAboutModal}
                    toggle={() => this.setState({ showAboutModal: !showAboutModal })}
                />
                <AccountSettingsModal
                    modal={showAccountSettingsModal}
                    toggle={() =>
                        this.setState({ showAccountSettingsModal: !showAccountSettingsModal })
                    }
                />
                <MyTeamsModal
                    modal={showMyTeamsModal}
                    toggle={() => this.setState({ showMyTeamsModal: !showMyTeamsModal })}
                />
            </nav>
        );
    }
}

export default withRouter(MainNavbar);
